export default {
	'扫一扫，微信支付':'Scan Wechat Payment',
	'金额':'Amount of money',
	'请在': 'Please pay in',
	'分': 'minute ',
	'秒内支付完成': 'seconds',
}


// WEBPACK FOOTER //
// ./src/i18n/en-us/qrCode.js